<section class="page">
  <div class="page-header">
    <div>
      <h1>Product Click Events</h1>
      <p>Member clicks on product tiles and product detail actions.</p>
    </div>
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search all fields</mat-label>
      <input matInput [formControl]="searchControl" aria-label="Search product click events">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  @if (errorMessage) {
    <div class="error" role="alert">{{errorMessage}}</div>
  }

  <div class="table-wrapper">
    <table mat-table matSort matSortActive="occurredAt" matSortDirection="desc" [dataSource]="items">
      <ng-container matColumnDef="occurredAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Timestamp</th>
        <td mat-cell *matCellDef="let item">{{item.occurredAt | date:'medium'}}</td>
      </ng-container>
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>User name</th>
        <td mat-cell *matCellDef="let item">{{item.userName}}</td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let item">{{item.email}}</td>
      </ng-container>
      <ng-container matColumnDef="brand">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Brand</th>
        <td mat-cell *matCellDef="let item">{{item.brand || '—'}}</td>
      </ng-container>
      <ng-container matColumnDef="rewardTileName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Reward tile name</th>
        <td mat-cell *matCellDef="let item">{{item.rewardTileName}}</td>
      </ng-container>
      <ng-container matColumnDef="eventType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Event type</th>
        <td mat-cell *matCellDef="let item">{{item.eventType}}</td>
      </ng-container>
      <ng-container matColumnDef="buttonLabel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Button</th>
        <td mat-cell *matCellDef="let item">{{item.buttonLabel || '—'}}</td>
      </ng-container>
      <ng-container matColumnDef="actionType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Action type</th>
        <td mat-cell *matCellDef="let item">{{item.actionType || '—'}}</td>
      </ng-container>
      <ng-container matColumnDef="surface">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Surface</th>
        <td mat-cell *matCellDef="let item">{{item.surface}}</td>
      </ng-container>
      <ng-container matColumnDef="sourceType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Source type</th>
        <td mat-cell *matCellDef="let item">{{item.sourceType || '—'}}</td>
      </ng-container>
      <ng-container matColumnDef="sourceId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Source ID</th>
        <td mat-cell *matCellDef="let item">{{item.sourceId || '—'}}</td>
      </ng-container>
      <ng-container matColumnDef="route">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Route</th>
        <td mat-cell *matCellDef="let item">{{item.route || '—'}}</td>
      </ng-container>
      <ng-container matColumnDef="metadata">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Metadata</th>
        <td mat-cell *matCellDef="let item"><code>{{item.metadata || '—'}}</code></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
    </table>
    @if (!loading && items.data.length === 0 && !errorMessage) {
      <div class="empty">No product click events found.</div>
    }
  </div>

  <mat-paginator
    [length]="total"
    [pageSize]="100"
    [pageSizeOptions]="[25, 50, 100, 250, 500]"
    showFirstLastButtons>
  </mat-paginator>
</section>
